import React, { useState } from "react";
import Layout from "../form-layout";

function gapKeyFromDate(dateString) {
  if (!dateString) return null;
  const days = Math.floor((Date.now() - new Date(dateString).getTime()) / 86400000);
  if (days < 7) return "lt7";
  if (days <= 14) return "d7to14";
  if (days <= 28) return "d15to28";
  return "gt28";
}

// Form B Q3 — "When did you take your most recent dose?" The computed gap feeds the
// same lastDoseGap flag the kept Q16 question uses, so a >28-day gap is flagged
// consistently regardless of which form a patient came through — this is the
// objective "current vs previous user" safety boundary discussed with the clinic:
// a self-reported "currently using" answer at the router doesn't override a >28-day
// gap found here; computeFinalTier() will still flag it for a forced dose reset.
export default function LastDoseDate({ formData, setFormData, onBack, goToStep }) {
  const [date, setDate] = useState(formData.lastDoseDate || "");

  // Q2 (dose) is skipped on the way in when Q1 = "Other", so going back has to jump
  // straight to Q1 too — the default index-based onBack would otherwise land on the
  // skipped Q2 screen instead.
  const handleBack = () => {
    if (formData.currentGlp1Med === "other") {
      goToStep("b1");
    } else {
      onBack();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!date) return;

    const gap = gapKeyFromDate(date);
    setFormData((prev) => ({ ...prev, lastDoseDate: date, lastDoseGap: gap }));
    localStorage.setItem("lastDoseDate", date);
    localStorage.setItem("lastDoseGap", gap);

    goToStep("b4");
  };

  return (
    <Layout goToStep={goToStep} onBack={handleBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        When did you take your most recent dose?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="date"
          value={date}
          max={new Date().toISOString().slice(0, 10)}
          onChange={(e) => setDate(e.target.value)}
          className="border-2 border-sky-300 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#35C3D9]"
        />

        <div className="flex justify-start">
          <button
            type="submit"
            disabled={!date}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!date ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
